import { createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import { getSchedule } from '../../api/tranRoutes'

export const fetchSchedule = createAsyncThunk('fetchSchedule', async (params, thunkAPI) => {
  // console.log(params)
  const {
    tranRoutes: { route_id, direction, day_type_id },
  } = thunkAPI.getState()

  if (!route_id) {
    throw Error('route_id is required')
  }

  const data = await getSchedule({
    route_id,
    direction,
    day_type_id,
    date: dayjs().format('YYYY-MM-DD'),
    // date: '2025-01-17',
  })
  // console.log(data)
  return data
})
